import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=4aa8522e&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=4aa8522e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8522e",
  null
  
)

export default component.exports